import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { Grid, Paper, Typography } from '@material-ui/core';
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import ListIcon from '@material-ui/icons/List';

import QRScanner from './QRScanner';
import BuscadorManual from './BuscadorManual';

const AccionesBusqueda = ({ onParticipanteEncontrado, itemSeleccionado, eventoIndex }) => {
    const [qrOpen, setQrOpen] = useState(false);
    const [buscadorOpen, setBuscadorOpen] = useState(false);

    const eventParticipants = useSelector(
        (state) => state.registry.eventParticipants
    );


    const handleQRResult = async (id) => {
        const data = eventParticipants[id];
        console.log("AccionesBusqueda", data, id)
        if (data) {
            onParticipanteEncontrado({ ...data, _scanner: true, id });
        }
    };

    const handleSeleccionManual = (participante) => {
        onParticipanteEncontrado(participante);
    };

    return (
        <>
            <Grid container spacing={2} justify="center" style={{ marginTop: 16 }}>
                <Grid item xs={6} sm={6}>
                    <Paper
                        style={{ height: 150, padding: 16, textAlign: 'center', cursor: 'pointer', backgroundColor: "#e0f2f1", margin: 10 }}
                        onClick={() => setQrOpen(true)}
                    >
                        <CameraAltIcon style={{ fontSize: 60, color: '#ef4123' }} />
                        <Typography variant="h6">Escanear QR</Typography>
                    </Paper>
                </Grid>
                <Grid item xs={6} sm={6}>
                    <Paper
                        style={{ height: 150, padding: 16, textAlign: 'center', cursor: 'pointer', backgroundColor: "#e0f2f1", margin: 10 }}
                        onClick={() => setBuscadorOpen(true)}
                    >
                        <ListIcon style={{ fontSize: 60, color: '#ef4123' }} />
                        <Typography variant="h6">Buscar por nombre o número</Typography>
                    </Paper>
                </Grid>
            </Grid>

            <QRScanner open={qrOpen} onClose={() => setQrOpen(false)} onResult={handleQRResult} />
            <BuscadorManual
                open={buscadorOpen}
                onClose={() => setBuscadorOpen(false)}
                onSeleccion={handleSeleccionManual}
            />
        </>
    );
};

export default AccionesBusqueda;

